<template>
    <div class="provider-line-page pt-10">
        <v-row class="qrcodeArea">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="col-10 col-md-6">
                <div class="mb-6 title">邀請商家</div>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="text-center col-10 col-md-6">
                <div></div>
                <div>
                    <div class="mb-2">邀請成為商家</div>
                    <v-btn color="primary" @click="invitePopup()">
                        點我邀請客戶
                    </v-btn>
                </div>
                <div></div>
            </v-col>
        </v-row>
        
        <v-row class="storeLinkArea inputArea mt-10">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="text-center col-10 col-md-6">
                <div class="title mb-4">商品列表:</div>
                <div class="d-flex align-center">
                    <v-text-field :value="productListLink" outlined dense disabled hide-details
                        class="align-center"></v-text-field>
                    <v-btn color="primary" @click="copy(productListLink)">
                        <v-icon size="14">fa
                            fa-copy</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="storeLinkArea inputArea mt-10">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="text-center col-10 col-md-6">
                <div class="title mb-4">訂單列表:</div>
                <div class="d-flex align-center">
                    <v-text-field :value="orderListLink" outlined dense disabled hide-details
                        class="align-center"></v-text-field>
                    <v-btn color="primary" @click="copy(orderListLink)">
                        <v-icon size="14">fa
                            fa-copy</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="storeLinkArea inputArea mt-10">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="text-center col-10 col-md-6">
                <div class="title mb-4">常用購物清單:</div>
                <div class="d-flex align-center">
                    <v-text-field :value="favoriteCartLink" outlined dense disabled hide-details
                        class="align-center"></v-text-field>
                    <v-btn color="primary" @click="copy(favoriteCartLink)">
                        <v-icon size="14">fa
                            fa-copy</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row class="storeLinkArea inputArea mt-10">
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="text-center col-10 col-md-6">
                <div class="title mb-4">應付款:</div>
                <div class="d-flex align-center">
                    <v-text-field :value="applyPayLink" outlined dense disabled hide-details
                        class="align-center"></v-text-field>
                    <v-btn color="primary" @click="copy(applyPayLink)">
                        <v-icon size="14">fa
                            fa-copy</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters('base', [
            'layoutProviderLineAtId',
            'layoutProviderStoreLineAtId',
            'frontendDomain',
        ]),
        QRCodeSRC() {
            return `https://qr-official.line.me/gs/M_${this.layoutProviderLineAtId}_GW.png`
        },
        storeQRCodeSRC() {
            return `https://qr-official.line.me/gs/M_${this.layoutProviderStoreLineAtId}_GW.png`
        },
        lineLink() {
            return `https://line.me/ti/p/~${this.layoutProviderLineAtId}`
        },
        storeLineLink() {
            return `https://line.me/R/ti/p/${this.layoutProviderStoreLineAtId}`
        },
        productListLink() {
            return `${this.frontendDomain}/provider-store/${this.providerId}/product/list`
        },
        orderListLink() {
            return `${this.frontendDomain}/provider-store/${this.providerId}/orders`
        },
        favoriteCartLink() {
            return `${this.frontendDomain}/provider-store/${this.providerId}/favorite`
        },
        applyPayLink() {
            return `${this.frontendDomain}/provider-store/${this.providerId}/apply-pay/overview`
        },
        providerName() {
            return this.$store.getters['member/providerName'];
        },
        providerId() {
            return this.$store.getters['member/providerId'];
        },
        storeLiffDomain() {
            return this.$store.getters[`base/storeLiffDomain`]
        },
    },
    methods: {
        async invitePopup() {
            const inviteCooperateData = await this.createInviteCooperateData()
            if (!inviteCooperateData) return
            const inviteRoute = {
                name: 'store-invite-cooperate',
                params: {
                    providerId: this.providerId,
                    inviteCooperateId: inviteCooperateData.id,
                },
                query: {
                    target: inviteCooperateData.target,
                    otp: inviteCooperateData.code,
                }
            }
            const href = this.$router.resolve(inviteRoute).href
            const url = `${this.frontendDomain}${href}`
            const uuid = `${this.providerId}-line-invite-popup`
            const shareText = `👋 我是【${this.providerName}】
邀請您加入我們的商家合作夥伴！

📩 請點選以下連結完成申請流程：
⚠️ 若您尚未註冊為「徠能商家」，請先完成商家註冊，再點選下方連結，否則將無法完成合作流程。

👉 ${url}

⚠️ 注意事項：

此連結僅限使用一次

有效期限：${inviteCooperateData.expiredAt}
`

            this.$apopup.base({
                title: `掃描QR Code邀請成為商家`,
                width: '550px',
                bodySlot: () => import('./providerLine/lineInvitePopup.vue'),
                actionSlot: () => import('./providerLine/copyButton.vue'),
                uuid,
                inviteCooperateLink: url,
                expiredAt: inviteCooperateData.expiredAt,
                shareText,
                disabledApply: true,
            })
        },
        async createInviteCooperateData() {
            this.$store.dispatch('loading/active')
            try {
                const inviteCooperateData = await this.$api.collection.providerApi.createInviteCooperateData(this.providerId)
                return inviteCooperateData
            } catch (error) {
                this.$snotify.error(error.message, `建立邀請連結失敗`)
            } finally {
                this.$store.dispatch('loading/close')
            }
        },
        copy(copyText) {
            navigator.clipboard.writeText(copyText)
                .then(() => {
                    this.$snotify.success(null, `已成功複製!`)
                })
        }
    }
}
</script>

<style lang="sass">
.provider-line-page
    .inputArea
        input
            text-align: center !important
            color: rgba(0, 0, 0, 0.87) !important
        fieldset
            border-top-right-radius: initial !important
            border-bottom-right-radius: initial !important
        
        button
            border-top-left-radius: initial !important
            border-bottom-left-radius: initial !important
            height: 40px !important
</style>